import React, { useState, useEffect } from 'react';
import ReactDOMClient from 'react-dom/client';
import { OptionalState } from '../utils/ReactHelper';
import Logger from '../../common/utils/Logger';
import Linker from '../library/Linker';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'

import Header from './components/Header';
import Container from 'react-bootstrap/Container';
import Home from './components/Home';
import Auth from './components/Auth';
import { PagePath } from './PagePath';
import Charts from './components/Chart';

type Props = {
    linker: Linker;
    label: string;
};

type State = {
    refresh: number;
    isBusy: boolean;
    path: string;
};

const StateDefault: State = {
    refresh: 0,
    isBusy: false,
    path: '',
};

const Index = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            await props.linker.Init();
            updateState({
                refresh: state.refresh + 1
            });
        });
    }, []);

    const AuthWidget = () => {
        if (!props.linker.User) return (<Auth linker={props.linker} path={state.path}></Auth>);
        OpenPath(PagePath.Home);
    };

    const OpenPath = (path: string) => {
        updateState({
            path: path
        });
    };

    const CheckPath = () => {
        let path: string = location.pathname;
        window.history.replaceState(null, "", "/");
        if (path == '/') {
            path = PagePath.Home;
        }
        updateState({
            path: path
        });
    };

    return (

        <React.StrictMode>
            <BrowserRouter>
                <Container>
                    <Header linker={props.linker} openPath={OpenPath} path={state.path} ></Header>
                </Container>
                {state.path == '' && <>{CheckPath()}</>}
                {state.path == PagePath.Home && <Home linker={props.linker} />}
                {state.path == PagePath.Chart && <Charts linker={props.linker} />}
                {(state.path == PagePath.AuthLogin || state.path == PagePath.AuthSignUp) && <>{AuthWidget()}</>}
            </BrowserRouter>
        </React.StrictMode>
    );
};

let linker: Linker = new Linker();
let root: ReactDOMClient.Root = ReactDOMClient.createRoot(document.getElementById('root') as HTMLElement);
let index: JSX.Element = <Index label='Index' linker={linker} />;
root.render(index);